import React, {ReactElement} from "react";
import {ButtonBase} from "@mui/material";
import {PD_SM} from "../../shared/dimens";

type TextPreset = {
  label: string;
  text: string;
  fontSize: number;
  fontStyle: string;
}

const TEXT_PRESETS: TextPreset[] = [
  {label: "Add a heading", text: "Add a heading", fontSize: 48, fontStyle: "bold"},
  {label: "Add a subheading", text: "Add a subheading", fontSize: 32, fontStyle: "normal"},
  {label: "Add body text", text: "Add body text", fontSize: 18, fontStyle: "normal"},
];

export function TextPanel(props: {
  onTextAdd: (text: string, fontSize: number, fontStyle: string) => void;
}): ReactElement {
  return (
    <div style={{display: "flex", flexDirection: "column", gap: PD_SM, padding: PD_SM}}>
      {TEXT_PRESETS.map((preset) => (
        <ButtonBase
          key={preset.label}
          onClick={() => props.onTextAdd(preset.text, preset.fontSize, preset.fontStyle)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: `${PD_SM}px ${PD_SM * 2}px`,
            borderRadius: 8,
            border: "1px solid #e0e0e0",
            textAlign: "left",
            fontSize: Math.min(preset.fontSize, 24),
            fontWeight: preset.fontStyle === "bold" ? 700 : 400,
          }}>
          {preset.label}
        </ButtonBase>
      ))}
    </div>
  );
}
